import React from 'react'
import { Outlet } from 'react-router-dom'
import Navbar from '../Navbar/Navbar.jsx'
import ScrollToTop from './../ScrollToTop/ScrollToTop';
import { CategoriesNav } from '../CategoriesNav/CategoriesNav.jsx';
import Footer from '../Footer/Footer.jsx';
// import SearchNav from '../SearchNav/SearchNav.jsx';


const Layout = () => {
    return (
        <div>
            <ScrollToTop />
            <Navbar />
            {/* <SearchNav /> */}
            <CategoriesNav />
            <div className="my-5 min-h-screen">
                <Outlet></Outlet>
            </div>
            <Footer />
        </div>
    )
}

export default Layout